// extracted by mini-css-extract-plugin
export default {"parent-mode":"qrcode-auth_parent-mode__zqRTS","subtext":"qrcode-auth_subtext__iW-1X"};